import React, { useEffect, useState } from "react";
const moment = require("moment");
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineDateRange } from "react-icons/md";
import styles from "./datepicker.module.scss";
export const DatePickerComponent = ({
  className,
  name,
  selected,
  onSelect,
  onChange,
  onBlur,
  onFocus,
  onCalendarClose,
  onCalendarOpen,
  onWeekSelect,
  onMonthChange,
  onYearChange,
  onDayMouseEnter,
  min,
  max,
}) => {
  const [value, setValues] = useState();
  const [minDate, setMinDate] = useState(false);
  const [maxDate, setMaxDate] = useState(false);

  //on Select
  const handleSelect = (dateString) => {
    let value = moment(dateString);
    if (value.isValid()) {
      let target = { name, value: value.format("YYYY-MM-DD") };
      if (onSelect) onSelect({ target });
    } else {
      let target = { name, value: undefined };
      if (onSelect) onSelect({ target });
    }
  };

  //on Change
  const handleChange = (dateString) => {
    let value = moment(dateString);
    if (value.isValid()) {
      let target = { name, value: value.format("YYYY-MM-DD") };
      if (onChange) onChange({ target });
    } else {
      let target = { name, value: undefined };
      if (onChange) onChange({ target });
    }
  };

  //on blur
  const handleBlur = (dateString) => {
    let value = moment(dateString).format("YYYY-MM-DD");
    let target = { name, value };
    if (onBlur) onBlur({ target });
  };

  //on  Focus
  const handleFocus = (dateString) => {
    let value = moment(dateString).format("YYYY-MM-DD");
    let target = { name, value };
    if (onFocus) onFocus({ target });
  };

  //when week change
  const handleWeekSelect = (e) => {
    console.log("week select");
    console.log(e);
  };

  //when month change
  const handleMonthChange = (e) => {
    console.log("month select");
    console.log(e);
  };

  //when year change
  const handleYearChange = (e) => {
    console.log("Year select");
    console.log(e);
  };

  //when mouse hover
  const handleDayMouseEnter = (e) => {
    console.log("mouse enter");
    console.log(e);
  };

  //disable input option on date picker
  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (selected && selected != "") {
      const selectedDate = moment(selected);
      if (selectedDate.isValid()) {
        setValues(new Date(selectedDate));
      } else {
        setValues("");
      }
    } else {
      setValues("");
    }

    if (min) {
      const minumDate = moment(min);
      if (minumDate.isValid()) {
        setMinDate(new Date(minumDate));
      }
    }

    if (max) {
      const maximumDate = moment(max);
      if (maximumDate.isValid()) {
        setMaxDate(new Date(maximumDate));
      }
    }
  }, [selected, min, max]);

  return (
    <div className={styles.pickearWrapper}>
      <DatePicker
        className={className}
        name={name}
        selected={value}
        dateFormat="dd/MM/yyyy"
        onChange={handleChange}
        onChangeRaw={handleDateChangeRaw}
        placeholderText="dd/mm/yyyy"
        // onSelect={handleSelect}
        // onBlur={handleBlur}
        // onFocus={handleFocus}
        // onWeekSelect={handleWeekSelect}
        // onMonthChange={handleMonthChange}
        // onYearChange={handleYearChange}
        // onDayMouseEnter={handleDayMouseEnter}
        minDate={minDate ? minDate : ""}
        maxDate={maxDate ? maxDate : ""}
        autoComplete="off"
        showYearDropdown
        showMonthDropdown
        dropdownMode="scroll"
      />
      <span className={styles.pickerIcon}>
        <MdOutlineDateRange />
      </span>
    </div>
  );
};

export default DatePickerComponent;
